require('../../css/components/PlaylistSlat.scss');

'use strict';
